import React, { useMemo, useRef } from "react";
import Index from "../../Index";
import PropTypes from "prop-types";
import { useState } from "react";
import Modal from "../../../component/modal/Modal";
import AutoWidthHeight from "../../../component/common/AutoWidthHeight";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { isTimeView } from "@mui/x-date-pickers/internals/utils/time-utils";
import FileSaver from "file-saver";
import * as XLSX from "xlsx-color";
import { manageModalParameter } from "../../../redux/user/action";
import Constants from "../../../component/common/constants";
import useRowPerPage from "../../../component/hooks/useRowPerPage";

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Index.Box sx={{ p: 3 }}>
          <Index.Typography>{children}</Index.Typography>
        </Index.Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const columns = [
  {
    field: "id",
    headerName: "Sr.",
    width: 130,
    hideable: false,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "script",
    headerName: "Script",
    // width: 360,
    width: 220,
    editable: false,
    sortable: false,
    filterable: false,
    headerAlign: "center",
    align: "center",
    // hideable: true,
  },
  {
    field: "tag",
    headerName: "Trade",
    width: 150,
    editable: false,
    headerAlign: "center",
    align: "center",
    sortable: false,
    filterable: false,
    renderCell: (params) => (
      <Index.Button
        className={
          params.value.toLowerCase() === "buy"
            ? "green-buy-btn"
            : params.value.toLowerCase() === "sell"
            ? "red-buy-btn"
            : params.value.toLowerCase() === "watch"
            ? "blue-watch-btn"
            : "green-buy-btn"
        }
        disableRipple
      >
        {params.value}
      </Index.Button>
    ),
  },
  {
    field: "timeFrame",
    headerName: "Interval",
    // width: 180,
    width: 200,
    editable: false,
    sortable: false,
    filterable: false,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "entry",
    headerName: "Entry",
    type: "number",
    // width: 180,
    width: 150,
    editable: false,
    sortable: false,
    filterable: false,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "entryDateTime",
    headerName: "Entry Date & Time",
    type: "number",
    width: 260,
    // width: 150,
    editable: false,
    sortable: false,
    filterable: false,
    headerAlign: "center",
    align: "center",
    padding: 0,
    renderCell: (params) => (
      <Index.Box>
        <Index.Typography>
          {Index.moment(params?.value).format("DD/MM/YYYY HH:mm:ss")}
        </Index.Typography>
      </Index.Box>
    ),
  },
  {
    field: "hitStatus",
    headerName: "Achieved",
    // width: 360,
    width: 180,
    editable: false,
    sortable: false,
    filterable: false,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "exit",
    headerName: "Exit",
    type: "number",
    // width: 190,
    width: 150,
    editable: false,
    sortable: false,
    filterable: false,
    headerAlign: "center",
    align: "center",
    padding: 0,
  },
  {
    field: "exitDateTime",
    headerName: "Exit Date & Time",
    type: "number",
    // width: 180,
    width: 250,
    editable: false,
    sortable: false,
    filterable: false,
    headerAlign: "center",
    align: "center",
    padding: 0,
    renderCell: (params) => (
      <Index.Box>
        <Index.Typography>
          {Index.moment(params?.value).format("DD/MM/YYYY HH:mm:ss")}
        </Index.Typography>
      </Index.Box>
    ),
  },
  {
    field: "profit",
    headerName: "Profit & loss in Points (%)",
    type: "number",
    // width: 295,
    width: 310,
    editable: false,
    sortable: false,
    filterable: false,
    headerAlign: "center",
    align: "center",
    padding: 0,
    renderCell: (params) => {
      return (
        <>
          <Index.Box
            className="MuiDataGrid-cellContent"
            sx={{
              color:
                params?.value?.[0] == "-"
                  ? "red"
                  : params?.value?.[0] == "+"
                  ? "#008000"
                  : "",
            }}
          >
            {params.value}
          </Index.Box>
        </>
      );
    },
  },
];

let performanceColumnHeader = {
  id: "Sr.",
  script: "Script",
  tag: "Trade",
  timeFrame: "Time Frame",
  interval: "Interval",
  entry: "Entry",
  entryDateTime: "Entry Date & Time",
  hitStatus: "Achieved",
  exit: "Exit",
  exitDateTime: "Exit Date & Time",
  profit: "Profit & loss in Points (%)",
};

let orderColumnHeader = {
  id: "Sr.",
  script: "Script",
  tag: "Trade",
  timeFrame: "Time Frame",
  interval: "Interval",
  entry: "Entry",
  StopLoss: "Stop Loss",
  Target: "Target",
  entryDateTime: "Entry Date & Time",
};

const PerformanceReport = (props) => {
  // state start
  const dispatch = useDispatch();
  const location = Index.useLocation();
  const userLoginToken = Index.useSelector((state) => state.UserReducer.token);
  const {
    displaySettings,
    chartView,
    twoSideArrowZoom,
    sorting,
    isActiveShortCut,
    isUserLogin,
      userLoginDetail,
      rowsPerPage: reduxRowsPerPage,
  } = Index.useSelector((state) => state.UserReducer);
  const position = Index.useSelector((state) => state.UserReducer.position);
  const { height, width } = AutoWidthHeight();
  const dataGridRef = useRef(null);
  const [reportModal, setreportModal] = useState(false);
  const [value, setValue] = useState(0);
  const [pageData, setPageData] = useState([]);
  const [excelData, setExcelData] = useState(null);
  const [allTagsData, setAllTagsData] = useState([]);
  const [tempAllTagsData, setTempAllTagsData] = useState([]);
  const [tab, setTab] = useState(0);
  const [count, setCount] = useState(0);
  const [pageValue, setPageValue] = useState(1);
  const [orderReportData, setOrderReportData] = useState([]);
  const [filters, setFilters] = useState({});
  const [opacity, setOpacity] = useState(1);
  const [loader, setLoader] = useState(true);
  const [dataTableHeight, setDataTableHeight] = useState(0);
  const [selectionRow, setSelectionRow] = useState(0);
  const apiRef = useRef();
  const gridWrapperRef = useRef(null);
  const [orderColumnVisibilityModel, setOrderColumnVisibilityModel] = useState(
    {}
  );
  const [
    performanceColumnVisibilityModel,
    setPerformanceColumnVisibilityModel,
  ] = useState({});

  useEffect(() => {
    setOrderColumnVisibilityModel({
      id: true,
      script: true,
      tag: true,
      ...(chartView === "Positional" ? { timeFrame: true } : {}),
      interval: true,
      entry: true,
      StopLoss: true,
      Target: true,
      entryDateTime: true,
    });
    setPerformanceColumnVisibilityModel({
      id: true,
      script: true,
      tag: true,
      ...(chartView === "Positional" ? { timeFrame: true } : {}),
      interval: true,
      entry: true,
      entryDateTime: true,
      hitStatus: true,
      exit: true,
      exitDateTime: true,
      profit: true,
    });
  }, [chartView]);

  //Download Excel file
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";

  const handleDownloadExcel = (apiData, fileName, headers) => {
    const applyCellStyle = (cell, style, ws, index, isBody) => {
      ws[cell].s = {
        font: {
          sz: style?.fontSize && style?.fontSize,
          color: { rgb: style?.fontColor || "FFFFFF" },
          bold: style.bold,
          italic: style.italic,
          underline: style.underline,
        },
        fill: {
          patternType: "solid",
          fgColor: { rgb: style.fillColor },
        },
        alignment: { horizontal: "center", vertical: "center" },
        border: {
          top: { style: "thin", color: { rgb: isBody ? "bfbfbf" : "FFFFFF" } },
          left: { style: "thin", color: { rgb: isBody ? "bfbfbf" : "FFFFFF" } },
          bottom: {
            style: "thin",
            color: { rgb: isBody ? "bfbfbf" : "FFFFFF" },
          },
          right: {
            style: "thin",
            color: { rgb: isBody ? "bfbfbf" : "FFFFFF" },
          },
        },
      };
    };

    const applyStylesToRow = (row, styles, ws, isBody) => {
      if (isBody) {
        row.forEach((row, i) => {
          row.forEach((cell, index) => {
            let fillColor =
              index === 2 && apiData[i]?.Trade === "Buy"
                ? "008000"
                : index === 2 && apiData[i]?.Trade === "Sell"
                ? "FF0000"
                : index === 2 && apiData[i]?.Trade === "Watch"
                ? "3a6dd6"
                : "FFFFFF";
            let fontColor =
              index === 9 || index === 10
                ? apiData[i]?.["Profit & loss in Points (%)"]?.charAt(0) === "+"
                  ? "008000"
                  : apiData[i]?.["Profit & loss in Points (%)"]?.charAt(0) ===
                    "-"
                  ? "FF0000"
                  : "000000"
                : index === 2 &&
                  ["Buy", "Sell", "Watch"].includes(apiData[i]?.Trade)
                ? "FFFFFF"
                : "000000";

            applyCellStyle(
              cell,
              { ...styles[index], fillColor, fontColor },
              ws,
              i,
              isBody
            );
          });
        });
      } else {
        row.forEach((cell, index) => {
          applyCellStyle(cell, styles[index], ws, index);
        });
      }
    };

    const wsData = [];

    //Row Data
    const mainHeading = [`${chartView} Report Data`];
    const headersKeys = [];
    for (var key in headers) {
      headersKeys.push(key);
    }

    wsData.push(mainHeading);
    wsData.push(headersKeys);
    apiData.forEach((item) => {
      wsData.push(Object.values(item));
    });

    //Series Data

    const mainHeaderRow = ["A1"];

    const RowA = headersKeys.map((_, colIndex) => {
      return XLSX.utils.encode_cell({ r: 1, c: colIndex });
    });

    const RowB = apiData.map((_, index) => {
      return headersKeys.map((_, colIndex) => {
        return XLSX.utils.encode_cell({ r: index + 2, c: colIndex });
      });
    });

    const stylesMainHeader = Array.from({ length: 1 }, (_, index) => {
      return {
        fontSize: 15,
        fillColor: "003366",
        bold: true,
        italic: false,
        underline: false,
      };
    });
    const stylesRowA = Array.from(
      { length: headersKeys?.length },
      (_, index) => {
        return {
          fillColor: "004C99",
          bold: true,
          italic: false,
          underline: false,
        };
      }
    );

    const stylesRowB = Array.from(
      { length: headersKeys?.length },
      (_, index) => {
        return {
          fontColor: "000000",
          fillColor: "FFFFFF",
          bold: false,
          italic: false,
          underline: false,
        };
      }
    );

    const ws = XLSX.utils.aoa_to_sheet(wsData);

    applyStylesToRow(mainHeaderRow, stylesMainHeader, ws, false);
    applyStylesToRow(RowA, stylesRowA, ws, false);
    applyStylesToRow(RowB, stylesRowB, ws, true);

    const mainHeadingRange = {
      s: { r: 0, c: 0 },
      e: { r: 0, c: headersKeys.length - 1 },
    };
    ws["!merges"] = [mainHeadingRange];

    //Set Cell Width

    let colWidth;
    if (value === 1) {
      colWidth = [
        { wch: 10 },
        { wch: 30 },
        { wch: 10 },
        ...(chartView === "Positional" ? [{ wch: 15 }] : []),
        { wch: 10 },
        { wch: 10 },
        { wch: 10 },
        { wch: 10 },
        { wch: 25 },
      ];
    } else {
      colWidth = [
        { wch: 10 },
        { wch: 30 },
        { wch: 10 },
        { wch: 10 },
        { wch: 10 },
        ...(chartView === "Positional" ? [{ wch: 15 }] : []),
        { wch: 25 },
        { wch: 10 },
        { wch: 10 },
        { wch: 25 },
        { wch: 25 },
      ];
    }
    ws["!cols"] = colWidth;

    let rowHeights = [
      {
        hpt: 40,
      },
      { hpt: 25 },
    ];

    apiData?.forEach((_, index) => {
      rowHeights?.push({ hpt: 20 });
    });

    ws["!rows"] = rowHeights;

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, fileName);

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(blob, fileName + fileExtension);
  };

  const handleDownload = () => {
    if (chartView === "Intraday") {
      delete orderColumnHeader?.timeFrame;
      delete performanceColumnHeader?.timeFrame;
    } else {
      orderColumnHeader.timeFrame = "Time Frame";
      performanceColumnHeader.timeFrame = "Time Frame";
    }
    const visibleColumns =
      value === 0
        ? Object.keys(performanceColumnVisibilityModel).filter(
            (key) => performanceColumnVisibilityModel[key]
          )
        : Object.keys(orderColumnVisibilityModel).filter(
            (key) => orderColumnVisibilityModel[key]
          );

    const customExcelData = pageData?.map((item, index) => {
      const rowData = {};
      visibleColumns.forEach((column) => {
        const columnHeader =
          value === 0 ? performanceColumnHeader : orderColumnHeader;
        const columnName = columnHeader[column];
        const itemValue = item[column];

        switch (column) {
          case "id":
            rowData["Sr."] = index + 1;
            break;
          case "entryDateTime":
            rowData["Entry Date & Time"] =
              value === 0
                ? Index.moment(itemValue).format("DD/MM/YYYY HH:mm:ss") || "-"
                : itemValue || "-";

            break;
          case "exitDateTime":
            rowData["Exit Date & Time"] =
              Index.moment(itemValue).format("DD/MM/YYYY HH:mm:ss") || "-";
            break;
          default:
            rowData[columnName] = itemValue || "-";
        }
      });
      return rowData;
    });

    if (customExcelData?.length) {
      handleDownloadExcel(
        customExcelData,
        value === 0 ? "Performance Report" : "Order Report",
        customExcelData[0]
      );
    }
  };

  // function start

  const getAllReports = async () => {
    try {
      const { reset, order, tags, timeFrame } =
        sorting[Constants.sortingPath[location?.pathname]];
      const response = await Index.DataService(userLoginToken).get(
        Index.Api.user.getAllReports,
        {
          params: {
            tradeType: chartView,
            reportType: value,
            sortDate: reset ? reset : "",
            sort: order ? order : "",
            tags: tags,
            timeFrameSort: timeFrame ? timeFrame : "",
          },
        }
      );
      setAllTagsData(response?.data?.data);
      setTempAllTagsData(response?.data?.data);
      setTimeout(() => {
        setLoader(false);
      }, 1000);
    } catch (error) {
      setAllTagsData([]);
      setTempAllTagsData([]);
      setPageData([]);
      setTimeout(() => {
        setLoader(false);
      }, 1000);
    }
  };

  useEffect(() => {
    getAllReports();
  }, [value, chartView, sorting[Constants.sortingPath[location?.pathname]]]);

  useEffect(() => {
    if (!props?.socket || !userLoginDetail?._id) return;

    const refreshReports = () => getAllReports();
    const events = [
      `market_end_${userLoginDetail._id}`,
      `hit_status_action_${userLoginDetail._id}`,
      `tagging_action_${userLoginDetail._id}`,
    ];

    events.forEach((event) => props.socket.on(event, refreshReports));

    return () => {
      events.forEach((event) => props.socket.off(event, refreshReports));
    };
  }, [
    props?.socket,
    userLoginDetail?._id,
    value,
    chartView,
    sorting[Constants.sortingPath[location?.pathname]],
  ]);

  const handleChange = (event, newValue) => {
    setLoader(true);
    setValue(newValue);
    setSelectionRow(1);
    setPageValue(1);
    setFilters({});
    setPaginationModel({ page: 0, pageSize: rowsPerPage });
  };
  // function end

  const columns = [
    {
      field: "id",
      headerName: "Sr.",
      width: 130,
      hideable: false,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "script",
      headerName: "Script",
      // width: 360,
      width: 220,
      editable: false,
      sortable: false,
      filterable: false,
      headerAlign: "center",
      align: "center",
      // hideable: true,
    },
    {
      field: "tag",
      headerName: "Trade",
      width: 150,
      editable: false,
      headerAlign: "center",
      align: "center",
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <Index.Button
          className={
            params.value.toLowerCase() === "buy"
              ? "green-buy-btn"
              : params.value.toLowerCase() === "sell"
              ? "red-buy-btn"
              : params.value.toLowerCase() === "watch"
              ? "blue-watch-btn"
              : "green-buy-btn"
          }
          disableRipple
        >
          {params.value}
        </Index.Button>
      ),
    },
    ...(chartView === "Positional"
      ? [
          {
            field: "timeFrame",
            headerName: "Time Frame",
            // width: 180,
            width: 200,
            editable: false,
            sortable: false,
            filterable: false,
            headerAlign: "center",
            align: "center",
          },
        ]
      : []),
    {
      field: "interval",
      headerName: "Interval",
      // width: 180,
      width: 200,
      editable: false,
      sortable: false,
      filterable: false,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "entry",
      headerName: "Entry",
      type: "number",
      // width: 180,
      width: 150,
      editable: false,
      sortable: false,
      filterable: false,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "entryDateTime",
      headerName: "Entry Date & Time",
      type: "number",
      width: 260,
      // width: 150,
      editable: false,
      sortable: false,
      filterable: false,
      headerAlign: "center",
      align: "center",
      padding: 0,
      renderCell: (params) => (
        <Index.Box>
          <Index.Typography>
            {Index.moment(params?.value).format("DD/MM/YYYY HH:mm:ss")}
          </Index.Typography>
        </Index.Box>
      ),
    },
    {
      field: "hitStatus",
      headerName: "Achieved",
      // width: 360,
      width: 180,
      editable: false,
      sortable: false,
      filterable: false,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "exit",
      headerName: "Exit",
      type: "number",
      // width: 190,
      width: 150,
      editable: false,
      sortable: false,
      filterable: false,
      headerAlign: "center",
      align: "center",
      padding: 0,
    },
    {
      field: "exitDateTime",
      headerName: "Exit Date & Time",
      type: "number",
      // width: 180,
      width: 250,
      editable: false,
      sortable: false,
      filterable: false,
      headerAlign: "center",
      align: "center",
      padding: 0,
      renderCell: (params) => (
        <Index.Box>
          <Index.Typography>
            {Index.moment(params?.value).format("DD/MM/YYYY HH:mm:ss")}
          </Index.Typography>
        </Index.Box>
      ),
    },
    {
      field: "profit",
      headerName: "Profit & loss in Points (%)",
      type: "number",
      // width: 295,
      width: 310,
      editable: false,
      sortable: false,
      filterable: false,
      headerAlign: "center",
      align: "center",
      padding: 0,
      renderCell: (params) => {
        return (
          <>
            <Index.Box
              className="MuiDataGrid-cellContent"
              sx={{
                color:
                  params?.value?.[0] == "-"
                    ? "red"
                    : params?.value?.[0] == "+"
                    ? "#008000"
                    : "",
              }}
            >
              {params.value}
            </Index.Box>
          </>
        );
      },
    },
  ];

  // table data filter start
  const performanceReportRow = useMemo(() => {
    return allTagsData
      ?.filter((item) => item?.status === "Inactive")
      .map((item, index) => {
        const TotalInvestment = +item.entryPrice;
        const profitLoss = (item?.exitPrice - item?.entryPrice)?.toFixed(2);

        const profitLossPercent = (
          (profitLoss / parseInt(item.entryPrice)) *
          100
        )?.toFixed(2);

        const formattedEntryTime = new Date(
          item?.createdAt
        )?.toLocaleTimeString("en-US", { hour12: false });
        const formattedExitTime = new Date(item?.updatedAt)?.toLocaleTimeString(
          "en-US",
          { hour12: false }
        );
        const formattedDate = new Date(item?.updatedAt)?.toLocaleDateString(
          "en-GB"
        );

        return {
          id: index + 1,
          script: item?.stock_name,
          tag: item?.tag,
          timeFrame:
            Constants.shortPositionalTimeframe?.[+item?.positionalTimeFrame] ||
            "-",
          interval: item?.timeFrame || "-",
          token: JSON.parse(item?.token),
          entry: item?.entryPrice || "-",
          entryTime: formattedEntryTime || "-",
          entryDateTime: item?.createdAt || "-",
          targetStatus: item?.targetAt?.completed,
          stopLossStatus: item?.topLossAt?.completed,
          hitStatus:
            (item?.topLossAt?.completed && "Stop Loss") ||
            (item?.targetAt?.completed && "Target") ||
            (item?.autoSquareStatus && "Auto Square") ||
            "-",
          exit: item?.exitPrice || "-",
          ExitTime: formattedExitTime || "-",
          exitDateTime: item?.updatedAt || "-",
          date: formattedDate || "-",
          profit:
            // item?.topLossAt?.completed || item?.targetAt?.completed
            //   ?
            +item?.entryPrice > +item?.exitPrice
              ? `${profitLoss || 0} (${profitLossPercent}%)`
              : `+${profitLoss || 0} (+${profitLossPercent}%)`,
          // : " -",
        };
      });
  }, [allTagsData]);

  const OrderColumns = [
    {
      field: "id",
      headerName: "Sr.",
      width: 70,
      hideable: false,
      editable: false,
      sortable: false,
      filterable: false,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "script",
      headerName: "Script",
      // width: 390,
      width: 220,
      editable: false,
      sortable: false,
      filterable: false,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "tag",
      headerName: "Trade",
      width: 150,
      editable: false,
      sortable: false,
      filterable: false,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <Index.Button
          className={
            params.value.toLowerCase() === "buy"
              ? "green-buy-btn"
              : ["sell", "exit"].includes(params.value.toLowerCase())
              ? "red-buy-btn"
              : params.value.toLowerCase() === "watch"
              ? "blue-watch-btn"
              : "green-buy-btn"
          }
          disableRipple
        >
          {params.value}
        </Index.Button>
      ),
    },
    ...(chartView === "Positional"
      ? [
          {
            field: "timeFrame",
            headerName: "Time Frame",
            // width: 180,
            width: 150,
            editable: false,
            sortable: false,
            filterable: false,
            headerAlign: "center",
            align: "center",
          },
        ]
      : []),
    {
      field: "interval",
      headerName: "Interval",
      // width: 180,
      width: 150,
      editable: false,
      sortable: false,
      filterable: false,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "entry",
      headerName: "Entry",
      type: "number",
      // width: 230,
      width: 150,
      editable: false,
      sortable: false,
      filterable: false,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "StopLoss",
      headerName: "Stop Loss",
      type: "number",
      // width: 230,
      width: 150,
      editable: false,
      sortable: false,
      filterable: false,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "Target",
      headerName: "Target",
      type: "number",
      // width: 200,
      width: 150,
      editable: false,
      sortable: false,
      filterable: false,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "entryDateTime",
      headerName: "Entry Date & Time ",
      type: "number",
      width: 268,
      editable: false,
      sortable: false,
      filterable: false,
      headerAlign: "center",
      align: "center",
    },
  ];

  const resizablePerformanceColumns = Index.useResizableColumns(
    columns,
    "performance-report",
    { apiRef }
  );
  const resizableOrderColumns = Index.useResizableColumns(
    OrderColumns,
    "performance-report-orders",
    { apiRef }
  );

  const orderReportRow = useMemo(() => {
    return allTagsData
      ?.filter((item) => item?.status === "Active")
      .map((item, index) => ({
        id: index + 1,
        script: item?.stock_name,
        tag: item?.tag,
        timeFrame:
          Constants.shortPositionalTimeframe?.[+item?.positionalTimeFrame] ||
          "-",
        interval: item?.timeFrame || "-",
        token: JSON.parse(item?.token),
        CMP: item?.livePrice,
        entry: item?.entryPrice,
        StopLoss: item?.topLossAt?.price || "-",
        Target: item?.targetAt?.price || "-",
        entryDateTime: ` ${new Date(item?.createdAt)?.toLocaleDateString(
          "en-GB"
        )} \u00A0 ${new Date(item?.createdAt)?.toLocaleTimeString("en-US", {
          hour12: false,
        })}`,
        date: new Date(item?.createdAt)?.toLocaleDateString("en-GB") || "-",
      }));
  }, [allTagsData]);

  const handleElementClick = (e, xAxis, yAxis) => {
    dispatch(
      manageModalParameter({ x: e.clientX - xAxis, y: e.clientY + yAxis })
    );
  };

  useEffect(() => {
    if (value === 0) {
      setPageData(performanceReportRow);
    } else {
      setPageData(orderReportRow);
    }
  }, [orderReportRow, performanceReportRow, allTagsData]);

  const [calculatedRows] = useRowPerPage(
    dataGridRef,
    dataTableHeight,
    52,
    pageData
  );
  const rowsPerPage = reduxRowsPerPage || calculatedRows || 10;
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: rowsPerPage,
  });

  // pagination start
  const handlePageChange = (event, value) => {
    setPageValue(value);
  };
  let tableElement;
  const handleKeyDown = (e) => {
    const key = e.key;

    const currentPageStartIndex =
      paginationModel.page * paginationModel.pageSize;
    const currentPageEndIndex = Math.min(
      currentPageStartIndex + paginationModel.pageSize - 1,
      pageData.length - 1
    );
    const firstId = pageData[currentPageStartIndex]?.id;
    const lastRowId = pageData[currentPageEndIndex]?.id;

    tableElement = apiRef.current?.rootElementRef?.current;

    if (key === "ArrowDown") {
      if (!selectionRow || selectionRow <= 0) {
        setSelectionRow(firstId);
      } else if (selectionRow < lastRowId) {
        setSelectionRow((prev) => prev + 1);
      } else {
        e.preventDefault();
      }
    } else if (key === "ArrowUp") {
      if (selectionRow > firstId) {
        setSelectionRow((prev) => prev - 1);
      } else {
        e.preventDefault();
      }
    } else if (key === "ArrowRight") {
      if (selectionRow === 0) {
        setPaginationModel((prev) => {
          const nextPage = prev.page + 1;
          setSelectionRow(0);
          return { ...prev, page: nextPage };
        });
      } else if (tableElement) {
        tableElement.scrollLeft = 50;
      }
      e.preventDefault();
    } else if (key === "ArrowLeft") {
      if (selectionRow === 0 && paginationModel.page > 0) {
        setPaginationModel((prev) => {
          const prevPage = prev.page - 1;
          setSelectionRow(0);
          return { ...prev, page: prevPage };
        });
      } else if (tableElement) {
        tableElement.scrollLeft -= 50;
      }
      e.preventDefault();
    } else if (key === "Tab") {
      setSelectionRow(0);
    }
  };
  useEffect(() => {
    const gridElement = gridWrapperRef.current?.querySelector('[role="grid"]');
    if (gridElement) {
      gridElement.focus();
    }
  }, [paginationModel.page, selectionRow]);

  useEffect(() => {
    if (isActiveShortCut && isUserLogin) {
      window.addEventListener("keydown", handleKeyDown);
      return () => {
        window.removeEventListener("keydown", handleKeyDown);
      };
    }
  }, [isActiveShortCut, isUserLogin, selectionRow, paginationModel?.page]);

  useEffect(() => {
    // const rowsPerPage = 15;
    const countData = Math.ceil(
      value === 0
        ? performanceReportRow?.length / rowsPerPage
        : orderReportRow?.length / rowsPerPage
    );
    setCount(countData);
    const indexOfLastRow = pageValue * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const modifiedRows =
      value === 0
        ? performanceReportRow?.slice(indexOfFirstRow, indexOfLastRow)
        : orderReportRow?.slice(indexOfFirstRow, indexOfLastRow);
    // setPageData(modifiedRows);

    // if (modifiedRows.length===0 && pageValue>1) {
    //   setPageValue(pageValue-1)
    // }
  }, [pageValue, value, allTagsData]);

  // pagination end

  //Filter Report Data

  useEffect(() => {
    if (!tempAllTagsData) return;

    const filteredRows = tempAllTagsData.filter((ele) => {
      const entryDate = Index.moment(
        value === 0 ? ele?.updatedAt : ele?.createdAt
      ).format("DD-MM-YYYY");

      const fromDate =
        filters?.fromDate &&
        Index.moment(filters?.fromDate).format("DD-MM-YYYY");
      const toDate =
        filters?.toDate && Index.moment(filters?.toDate).format("DD-MM-YYYY");

      const filterConditions = [];

      if (filters?.market) {
        filterConditions.push(ele?.exchange_type === filters?.market);
      }
      if (filters?.script) {
        filterConditions.push(
          filters?.script === "All"
            ? ele
            : ele?.script?.toLowerCase() === filters?.script?.toLowerCase()
        );
      }
      if (!!filters?.tag?.length) {
        filterConditions.push(filters?.tag?.includes(ele?.tag));
      }
      if (filters?.stockName) {
        filterConditions.push(
          ele?.stock_name?.toLowerCase() === filters?.stockName?.toLowerCase()
        );
      }
      if (filters?.fromDate && filters?.toDate) {
        filterConditions.push(entryDate >= fromDate && entryDate <= toDate);
      }

      return filterConditions.every((condition) => condition);
    });

    setAllTagsData(filteredRows);
  }, [tempAllTagsData, filters, chartView]);

  useEffect(() => {
    setPaginationModel({
      page: 0,
      pageSize: rowsPerPage,
    });
  }, [rowsPerPage]);

  //Data table height
  let mainContentElement = document.querySelector(".main-content-sec");
  let tabSecElement = document.querySelector(".tab-wrapper");

  useEffect(() => {
    if (mainContentElement && tabSecElement) {
      const mainHeight = mainContentElement.clientHeight;
      const tabSecHeight = tabSecElement.clientHeight;
      setDataTableHeight(mainHeight - tabSecHeight - 30);
    }
  }, [mainContentElement, tabSecElement, twoSideArrowZoom]);

  return (
    <>
      <Index.Box className="dashboard-main performance-report-wrap">
        <Index.Header></Index.Header>
        <Index.Overlay></Index.Overlay>
        <Index.Box className="dashboard-wrapper">
          <Index.Box
            className={`main-content-sec ${
              displaySettings?.UtilityBar == "left"
                ? "main-content-sec-right"
                : ""
            } ${twoSideArrowZoom && "hide-main-content-margin"}`}
          >
            <Index.Box className="tab-content-main report-tab-content-main">
              <Index.Box sx={{ width: "100%" }} className="tab-details-content">
                <Index.Box
                  sx={{ borderBottom: 1, borderColor: "divider" }}
                  className="tab-wrapper tab-border-content"
                >
                  <Index.Tabs
                    value={value}
                    onChange={handleChange}
                    aria-label="basic tabs example"
                    className="tabs-content-top performance-report-top-btn"
                  >
                    <Index.Tab
                      label="Performance Report"
                      {...a11yProps(0)}
                      className="tabs-content-title report-tab-content-title"
                      disableRipple
                    />
                    <Index.Tab
                      label="Open Order Report"
                      {...a11yProps(1)}
                      className="tabs-content-title report-tab-content-title"
                      disableRipple
                    />
                  </Index.Tabs>
                  <Index.Box className="editRepot-download-sec">
                    {tempAllTagsData?.length > 0 && (
                      <Index.PrimaryButton
                        className="primary-btn edit-download-btn"
                        btnLabel="View Report"
                        onClick={(e) => {
                          handleElementClick(e, 200, 50);
                          setreportModal(!reportModal);
                        }}
                      />
                    )}
                    {pageData?.length > 0 && (
                      <Index.PrimaryButton
                        className="primary-btn edit-download-btn green-bg"
                        btnLabel="Download"
                        onClick={handleDownload}
                      />
                    )}
                  </Index.Box>
                </Index.Box>
                <Index.Box className="tab-body">
                  <TabPanel
                    value={value}
                    index={0}
                    className="report-tab-panel performance-tab"
                  >
                    <Index.Box className="">
                      <Index.Box
                        // className={`table-sec report-tab-sec ${
                        //   pageData?.length <= 10 ? "transaction-table" : ""
                        // }`}
                        className="table-sec report-tab-sec"
                      >
                        <Index.Box
                          sx={{ width: "100%", height: dataTableHeight }}
                          {...resizablePerformanceColumns.containerProps}
                          className={`user-tagged-scripts-performance ${resizablePerformanceColumns.containerProps.className}`}
                          ref={gridWrapperRef}
                          tabIndex={0}
                          style={{ outline: "none" }}
                        >
                          {/* {!loader ? (
                            pageData && pageData.length > 0 ? ( */}
                          <Index.DataGrid
                            apiRef={apiRef}
                            ref={dataGridRef}
                            rows={loader ? [] : pageData}
                            columns={resizablePerformanceColumns.columns}
                            initialState={{
                              pagination: {
                                paginationModel: {
                                  pageSize: 20,
                                },
                              },
                            }}
                            pageSizeOptions={[1000]}
                            paginationModel={paginationModel}
                            onPaginationModelChange={setPaginationModel}
                            // disableRowSelectionOnClick
                            components={{
                              NoRowsOverlay: () => (
                                <Index.NoRowsOverlay loader={loader} />
                              ),
                            }}
                            localeText={{
                              MuiTablePagination: {
                                labelDisplayedRows: ({
                                  from,
                                  to,
                                  count,
                                  estimated,
                                }) => {
                                  if (!estimated) {
                                    return `${from} – ${to} of ${
                                      count !== -1 ? count : `${to}`
                                    }`;
                                  }
                                  return `${from} – ${to} of ${
                                    count !== -1
                                      ? count
                                      : `${estimated > to ? estimated : to}`
                                  }`;
                                },
                              },
                            }}
                            rowSelectionModel={
                              selectionRow > 0 ? [selectionRow] : []
                            }
                            rowSelection
                            onRowSelectionModelChange={(
                              newRowSelectionModel
                            ) => {
                              if (newRowSelectionModel?.length > 0) {
                                const firstSelectedRowId =
                                  newRowSelectionModel[0];
                                setSelectionRow(firstSelectedRowId);
                                apiRef.current.scrollToIndexes({
                                  rowIndex: firstSelectedRowId,
                                });
                              }
                            }}
                            columnVisibilityModel={
                              performanceColumnVisibilityModel
                            }
                            onColumnVisibilityModelChange={(newModel) => {
                              setPerformanceColumnVisibilityModel(newModel);
                            }}
                          />
                          {/* ) : (
                              <Index.Box
                                sx={{ textAlign: "center", padding: "20px" }}
                                className="text-data"
                              >
                                Performance report not found
                              </Index.Box>
                            )
                          ) : (
                            <Index.TableLoader />
                          )} */}
                        </Index.Box>
                      </Index.Box>
                      {/* <Index.Footer /> */}
                    </Index.Box>
                  </TabPanel>
                  <TabPanel
                    value={value}
                    index={1}
                    className="report-tab-panel"
                  >
                    <Index.Box className="">
                      <Index.Box
                        // className={`table-sec report-tab-sec performance-report ${
                        //   pageData.length <= 10 ? "transaction-table" : ""
                        // }`}
                        className="table-sec report-tab-sec performance-report"
                      >
                        <Index.Box
                          sx={{ width: "100%", height: dataTableHeight }}
                          {...resizableOrderColumns.containerProps}
                          className={`open-order-report ${resizableOrderColumns.containerProps.className}`}
                        >
                          {/* {!loader ? (
                            pageData && pageData.length > 0 ? ( */}
                          <Index.DataGrid
                            apiRef={apiRef}
                            ref={dataGridRef}
                            rows={loader ? [] : pageData}
                            columns={resizableOrderColumns.columns}
                            initialState={{
                              pagination: {
                                paginationModel: {
                                  pageSize: 10,
                                },
                              },
                            }}
                            pageSizeOptions={[1000]}
                            paginationModel={paginationModel}
                            onPaginationModelChange={setPaginationModel}
                            // disableRowSelectionOnClick
                            components={{
                              NoRowsOverlay: () => (
                                <Index.NoRowsOverlay loader={loader} />
                              ),
                            }}
                            rowSelectionModel={
                              selectionRow > 0 ? [selectionRow] : []
                            }
                            rowSelection
                            onRowSelectionModelChange={(
                              newRowSelectionModel
                            ) => {
                              if (newRowSelectionModel?.length > 0) {
                                const firstSelectedRowId =
                                  newRowSelectionModel[0];
                                setSelectionRow(firstSelectedRowId);
                                apiRef.current.scrollToIndexes({
                                  rowIndex: firstSelectedRowId,
                                });
                              }
                            }}
                            localeText={{
                              MuiTablePagination: {
                                labelDisplayedRows: ({
                                  from,
                                  to,
                                  count,
                                  estimated,
                                }) => {
                                  if (!estimated) {
                                    return `${from} – ${to} of ${
                                      count !== -1 ? count : `${to}`
                                    }`;
                                  }
                                  return `${from} – ${to} of ${
                                    count !== -1
                                      ? count
                                      : `${estimated > to ? estimated : to}`
                                  }`;
                                },
                              },
                            }}
                            columnVisibilityModel={orderColumnVisibilityModel}
                            onColumnVisibilityModelChange={(newModel) => {
                              setOrderColumnVisibilityModel(newModel);
                            }}
                          />
                          {/* ) : (
                              <Index.Box
                                sx={{ textAlign: "center", padding: "20px" }}
                                className="text-data"
                              >
                                Open order report not found
                              </Index.Box>
                            )
                          ) : (
                            <Index.TableLoader />
                          )} */}
                        </Index.Box>
                      </Index.Box>
                      {/* <Index.Footer /> */}
                    </Index.Box>
                  </TabPanel>
                </Index.Box>
              </Index.Box>
            </Index.Box>
          </Index.Box>
          {/* <Index.SideBar></Index.SideBar> */}
        </Index.Box>
        {/* <Index.Footer data={allTagsData} setPageData={setPageData} /> */}
        {/* <Index.Box className="footer-sec">
          <Index.Box className="pagination-sec">
            <Index.Stack spacing={4}>
              <Index.Pagination
                // count={Math.ceil(wishListData?.length / 81)}
                count={count}
                page={pageValue}
                onChange={handlePageChange}
                shape="rounded"
              />
            </Index.Stack>
          </Index.Box>
        </Index.Box> */}
      </Index.Box>
      <Modal
        show={reportModal}
        // show={true}
        position={position}
        setShow={setreportModal}
        title={"Report"}
        x={position?.x}
        y={position?.y}
        width={"393px"}
        opacity={opacity}
        setOpacity={setOpacity}
        html={
          <Index.ReportModal
            setFilters={setFilters}
            filters={filters}
            setShow={setreportModal}
            row={tempAllTagsData}
          />
        }
      />
    </>
  );
};

export default PerformanceReport;
